import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUsers, FiShield, FiTrendingUp, FiZap } = FiIcons;

const CoteriePartnership = () => {
  const stats = [
    { number: "50K+", label: "Businesses Protected", icon: FiUsers },
    { number: "A-", label: "AM Best Rating", icon: FiShield },
    { number: "$2B+", label: "Coverage Written", icon: FiTrendingUp },
    { number: "99.9%", label: "Uptime", icon: FiZap }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="bg-white rounded-2xl p-8 shadow-xl inline-block mb-8">
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752036427196-Coterie_Logo_Trans_FullColor-1024x185.png" 
              alt="Coterie Insurance"
              className="h-20 w-auto mx-auto"
            />
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Trusted Technology Partner
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Backed by industry-leading insurance technology and financial strength
          </p>
        </motion.div>

        <div className="grid md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="bg-blue-50 w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto">
                <SafeIcon icon={stat.icon} className="text-blue-600 text-2xl" />
              </div>
              <div className="text-3xl font-bold text-blue-600 mb-2">{stat.number}</div>
              <div className="text-gray-600">{stat.label}</div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <motion.a
            href="https://quote.burbankinsuranceservices.com/Jn9lan"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-colors duration-300 inline-block"
          >
            Get Protected Today
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default CoteriePartnership;